'use strict'
import { serverApi } from '@/server';

export default {

    /**
     * 签约管理
     *
     * @author nick
     *
     * @method GET
     *
     * @url /api/agreements
     *
     * @returns {Promise}
     */
    getSignDetailsList(formData) {
        const url = '/agreements'
        return serverApi.get(formData, url);

    },
    /**
   * 身份证号脱敏查看
   *
   * @author nick
   *
   * @param {String} id
   *
   *
   * @returns {Promise}
   *
   */
    agreementsShowIdCard(id) {
        const url = `/agreements-show-idcard/${id}`

        return serverApi.get({}, url);
    },
    /**
     * 手机号脱敏查看
     *
     * @author nick
     *
     * @param {String} id
     *
     *
     * @returns {Promise}
     *
     */
    agreementsShowPhone(id) {
        const url = `/agreements-show-phone/${id}`

        return serverApi.get({}, url);
    },
    /**
   * 签约管理合同预览
   *
   * @author nick
   *
   * @method POST
   *
   * @url /api/contract-preview
   *
   * @returns {Promise}
   */
    contractPreviewIMG(formData) {
        const url = `/contract-preview`;
        return serverApi.preview(formData, url, { responseType: 'blob' },true);
    },
    /**
     * 签约管理合同预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /api/contract-preview
     *
     * @returns {Promise}
     */
    contractPreviewFile(formData) {
        const url = `/contract-preview`;
        return serverApi.post(formData, url);
    },
    /**
     * 签约管理合同下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /api/contract-download
     *
     * @returns {Promise}
     */
    contractDownload(formData, name) {
        const url = `/contract-download`
        return serverApi.downLoadByPost(formData, url, name)
    },
    

}
